module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "grid ovf border-top m2000",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "grid-item p2222 border-bottom border-right"
  }, [_vm._v("\n        Grid\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "grid-item p2222 border-bottom border-right"
  }, [_vm._v("\n        Grid\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "grid-item p2222 border-bottom border-right"
  }, [_vm._v("\n        Grid\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "grid-item p2222 border-bottom border-right"
  }, [_vm._v("\n        Grid\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "grid-item p2222 border-bottom border-right"
  }, [_vm._v("\n        Grid\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "grid-item p2222 border-bottom border-right"
  }, [_vm._v("\n        Grid\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "grid-item p2222 border-bottom border-right"
  }, [_vm._v("\n        Grid\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "grid-item p2222 border-bottom border-right"
  }, [_vm._v("\n        Grid\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "grid-item p2222 border-bottom border-right"
  }, [_vm._v("\n        Grid\n    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fec8426e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/other/playground/demo.vue
// module id = 284
// module chunks = 34